import { PaginationProps } from './Pagination';

export const usePagination = ({ currentPage, numPages, setCurrentPage }: PaginationProps) => {
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < numPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    return { handlePreviousPage, handleNextPage };
};
